import React, {useEffect} from 'react';
import { Routes, Route } from "react-router-dom";
import Navbar from "./components/nav/navbar";
import LandingPage from "./pages/LandingPage";
import EventsPage from "./pages/EventsPage";
import FinancePage from "./pages/FinancePage";
import AdvertPage from "./pages/AdvertPage";
import TrafficPage from "./pages/TrafficPage";
import LoggedInFooter from "./components/footer/logged-in-footer";
import DevtoolsPage from "./pages/DevtoolsPage";
import MonitoringPage from "./pages/MonitoringPage";
import {useDispatch} from "react-redux";
import {fetchAppVersionAsync} from "./features/api-info/api-infoSlice";
import NewsPage from "./pages/NewsPage";
import SongPage from "./pages/SongPage";
import SandBoxPage from "./pages/SandBoxPage";
import {useAuth} from "oidc-react";
import LoggedOutPage from "./pages/LoggedOutPage";
import {setRoles} from "./features/user/user-slice";
import {client} from "./socks-client";
import {NotificationsPage} from "./pages/NotificationsPage";
import {fetchNotificationsAsync} from "./features/notifications/notifcationSlice";
import StudyPage from "./pages/StudyPage";
import UserManagementPage from "./pages/UserManagementPage";
import {loadIAMGroupsAsync} from "./features/user-management/iamSlice";

const JCRoutes = () => {
    const auth = useAuth();
    const dispatch = useDispatch();


    useEffect(() => {
        if (auth && auth.userData) {
            dispatch(fetchAppVersionAsync(auth.userData?.access_token));

            if (auth.userData?.profile["cognito:groups"]) {
                dispatch(setRoles(auth.userData?.profile["cognito:groups"]))
            }
        }
    }, [auth.userData]);

    useEffect(() => {
        if (auth && auth.userData) {
            dispatch(fetchNotificationsAsync(auth.userData.access_token))
            dispatch(loadIAMGroupsAsync(auth.userData.access_token))
        }
    }, [auth.userData]);



    useEffect(() => {
        if (auth && auth.userData) {
            const userData = auth.userData;
            const userGroups = auth.userData?.profile["cognito:groups"];

            let xClient = client(userData.access_token);
            xClient.onConnect = () => {

                userGroups.forEach(group => {
                    xClient.subscribe(
                        `/user/notification/${group}/${userData.profile.sub}`,
                        (message) => {
                            const msg = JSON.parse(message.body)
                            console.log(msg);
                            dispatch(fetchNotificationsAsync(auth.userData.access_token));
                        },
                        {
                            authorization: `Bearer ${userData.access_token}`,
                            channelId: group,
                            resource: group,
                            resourceIds: JSON.stringify([]),
                        }
                    );
                })

                xClient.onStompError = (err) => {
                    console.error("WebSocket STOMP Error:", err);
                };
            };
            xClient.activate();
        }
    }, [auth.userData]);

    const landingPage =  auth && auth.userData ?
        <LandingPage/>
        :
        <LoggedOutPage/>

    return (
        <>
            {
                auth && auth.userData ?
                    <Navbar roles={[]}/>
                    :
                    null
            }

            <Routes>
                <Route path={'/'} element={landingPage}/>
                <Route path={'/loggedout'} element={<LoggedOutPage/>}/>
                <Route path={'/events'} element={<EventsPage/>}/>
                <Route path={'/finance'} element={<FinancePage/>}/>
                <Route path={'/advert'} element={<AdvertPage/>}/>
                <Route path={'/traffic'} element={<TrafficPage/>}/>
                <Route path={'/devtools'} element={<DevtoolsPage/>}/>
                {
                    process.env.NODE_ENV === 'development' ?
                        <Route path={'/sandbox'} element={<SandBoxPage/>}/>
                        :
                        null
                }

                <Route path={'/monitoring'} element={<MonitoringPage/>}/>
                <Route path={'/song'} element={<SongPage/>}/>
                <Route path={'/news'} element={<NewsPage/>}/>
                <Route path={'/notifications'} element={<NotificationsPage/>}/>
                <Route path={'/study-note'} element={<StudyPage/>}/>
                <Route path={'/users-management'} element={<UserManagementPage/>}/>
            </Routes>
            {
                auth && auth.userData ?
                    <LoggedInFooter/>
                    :
                    null
            }
        </>
    );
}

export default JCRoutes;
